import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Create root element for React 18
const root = ReactDOM.createRoot(document.getElementById("root"));

// Render the main App component
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// Performance monitoring (optional)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
